import api from "../auth/api";
import type { TabType, TrackTabAccessResponse } from "./tabs.type";

/**
 * Track tab access for a stock symbol.
 * Returns a UUID token that must be included in subsequent API calls.
 */
export const trackTabAccess = async (
  tabType: TabType,
  symbol: string
): Promise<TrackTabAccessResponse> => {
  const response = await api.post<TrackTabAccessResponse>(
    `/tabs/${tabType}/${symbol.toUpperCase()}`
  );
  return response.data;
};
